//  21 oct jyoti start
// Added Set Email Password Option

import React, { useState, useEffect } from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
import { useHistory } from "react-router-dom";
import {ApiURL} from '../constants/ApiUrl'
import axios from 'axios'


import "../styles/AdminSetEmailPass.css"

var AdminSetEmailPass= ()=> {
    const history = useHistory();
    const [Obj, setObj] = useState({
        email: '',
        password: ''
    });
    useEffect(()=>{
        a();
    },[])
    var a= async ()=>{
        try{
            const result = await axios.post(`${ApiURL}/api/get_api`);
            console.log(result,"resultyyyyyyyy")
            var e={
                email:result.data.email,
                password:result.data.password
            }
            
            setObj(e);
            console.log(e,"oooooooooooo")
        }catch(er){
            console.log(er)
        }
        

    }
    const handleSetEmailPassword = (values) => {
        console.log(values,"vvvvvvvvvvvv");
            AuthService.SetEmailPass(values.email,values.password).then(res => {
                console.log(res, "oooooo")
                alert(res)
                // if (res === "Set Email And Password successfully!!"){
                //     history.replace('/admin/dashboard');

                // }
            })
    }
    return (
        <div className="setMain">
            <div className="setContainer">
                <h4>Set Email Password</h4>
                {Obj.email !== "" && <Formik initialValues={Obj} onSubmit={handleSetEmailPassword}>
                    {
                        () => (
                            <Form>
                                <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="email" as={TextField}  label="Email" variant="outlined" type="email" />
                                    <Field name="password" as={TextField}  label=" Password" variant="outlined" type="password"/>
                                    <Button variant="contained" color="primary" type="submit">Update</Button>
                                </div>
                            </Form>
                        )
                    }
                </Formik>}
            </div>
        </div>
    )
}

export default AdminSetEmailPass

// 21 oct jyoti end
